import { cloneDeep } from 'lodash';
import { getVectorTextFromCache } from '@meitu/saas-editor-core/es/utils/file-kit';
import { ILayerProps, ITextContent, ITextLayerProps } from '@meitu/saas-editor-core/es/version-types';

export const TextArtDefaultText = '美图设计室';

export const TextArtDefaultFontFamily = 'Poppins-Medium';

// 默认舞台尺寸
export const TextArtDefaultStage = {
    width: 1100,
    height: 604,
};

// 缩略图尺寸
export const TextArtThumbnailSize = {
    width: 550,
    height: 302,
};

export const getSvgElement = (url: string) => {
    const svgText = getVectorTextFromCache(url);
    if (!svgText) return null;
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, 'image/svg+xml');
    return doc.documentElement;
};

// 获取花字 svg 的 use 个数
export const getUseCounts = (url: string) => {
    const svgElement = getSvgElement(url);
    if (!svgElement) return 0;
    const useElements = svgElement.querySelectorAll('use');
    return useElements.length;
};

/**
 * 普通文本图层转换为花字分段编辑数据
 *
 * @param layer - 文本图层
 * @returns ITextContent[] - 花字分段编辑数据
 */
export const transformToTextContents = (layer: ILayerProps): Omit<ITextContent, 'text'>[] => {
    const layerData = layer.data as ITextLayerProps;
    const { text, fontFamily, fontSize, color, bold, italic, lineThrough, underline } = layerData;

    const ret: Omit<ITextContent, 'text'>[] = [];
    const segmentIterator = new Intl.Segmenter().segment(text);

    let idx = 0;

    for (const segment of segmentIterator) {
        const nextContent: Omit<ITextContent, 'text'> = {
            // text: segment.segment,
            fontSize,
            fontFamily,
            color,
            bold,
            italic,
            lineThrough,
            underline,
            rotate: 0,
            scale: 1,
            offsetX: 0,
            offsetY: 0,
        };

        ret.push(nextContent);
        idx++;
    }

    return ret;
};

/**
 * 格式化文字特效图层
 * @param layer - 文字特效图层
 * @returns ITextLayerProps - 文字特效图层
 */

export const formatTextArtLayer = (layer: ILayerProps) => {
    const newLayer = cloneDeep(layer);
    const layerData = newLayer.data as ITextLayerProps;

    newLayer.top = 0;
    newLayer.left = 0;
    // newLayer.rotate = 0;
    // newLayer.opacity = 1;

    if (layerData.advancedTextMaterial) {
        const { material, textContents } = layerData.advancedTextMaterial;
        material.defaultLetterSpacing = layerData.letterSpacing;
        textContents.forEach((el) => {
            el.fontFamily = layerData.fontFamily;
            el.textStroke = layerData.textStroke;
            el.textShadow = layerData.textShadow;
            el.textGlow = layerData.textGlow;
            el.textBackground = layerData.textBackground;
        });
    }

    delete layerData.textContents;

    return newLayer;
};
